<script>
    import _           from 'lodash'
    import * as api    from './api.js'
    import GoogleOAuth from './GoogleOAuth.svelte'
    import { createEventDispatcher } from 'svelte'

    export let type
    export let domain
    
    let credential
    let credentials = []
    let loading = false

    const dispatch = createEventDispatcher()
    
    $: loadCredentialsByType(type, domain) || []

    function loadCredentialsByType(type, domain) {
        loading = true
        return api
            .post('/service-credentials', {
                kind: 'google-oauth', domain: domain.id
            })
            .then(api.toJsonIf200)
            .then(json => {
                loading = false
                credentials = json
            })
            .catch(console.log)
    }
  
    function storeToken(evt) {
        api
            .post('/service-credentials/create', {
                domain      : domain.id      , 
                kind        : "google-oauth" ,
                description : null           , //TODO: ask for a description
                payload     : evt.detail     , 
            })
            .then(api.toJsonIf200)
            .then(json => credentials = [...credentials, json])
            .catch(console.log)
    }

    function setCredential(selected) {
        return () => {
            credential = selected
            dispatch('done', credential)
        }
    }

    function active(credential, cred) {
        return credential && credential.id === cred.id
    }

    function labelFor(credential, cred) {
        return active(credential, cred) ? "selecionada" : "selecionar"
    }
</script>

<div class="ui segments">
    <div class="ui basic segment header">
        <h3 class="ui">Credenciais</h3>
    </div>
    <div class="ui basic segment" class:loading>
        {#each credentials as cred}
            <div class="ui basic segment">
                <button class="ui blue button"
                        class:disabled={ active(credential, cred) } 
                        on:click={setCredential(cred)}>{labelFor(credential, cred)}</button>
                {cred.username} - {cred.email}
            </div>
        {/each}
        <div class="ui basic segment">
            <GoogleOAuth on:access-granted={storeToken}></GoogleOAuth>
        </div>
    </div>
</div>